import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const setBrowsingModeWidgetContentFilter = createAction(
  `${reduxKey}.SET_BROWSINGMODE_WIDGET_CONTENT_FILTER`,
  (contentFilter: string) => ({ contentFilter })
);

export const saveBrowsingMode = createAction(
  `${reduxKey}.SAVE_BROWSING_MODE`,
  () => ({})
);

export const saveBrowsingModeSuccess = createAction(
  `${reduxKey}.SAVE_BROWSING_MODE_SUCCESS`,
  () => ({})
);

export const saveBrowsingModeFailure = createAction(
  `${reduxKey}.SAVE_BROWSING_MODE_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);
